import type { Media } from "@mw/shared/payload-types";
import type { ChatScenarioData } from "@ui/components/core/ChatScenario";
import type { ILink } from "@ui/components/core/Link";
import type { ReactNode, RefObject } from "react";

export interface ImageAccordionAsset {
  type?: "backgroundForegroundImage";
  background?: Media;
  foreground?: Media;
  overlay?: Media;
  theme?: "dark" | "light" | "transparent";
}

export interface VideoAccordionAsset {
  type: "video";
  video?: Media;
  overlayTitle?: string;
  overlayDescription?: string;
}

export interface ChatScenarioAccordionAsset {
  type: "chatScenario";
  agentName: string;
  anchor?: "bottom" | "top";
  scenario: ChatScenarioData;
}

export type AccordionAssetInput = ChatScenarioAccordionAsset | ImageAccordionAsset | VideoAccordionAsset;
export type NormalizedImageAsset = ImageAccordionAsset & { type: "backgroundForegroundImage" };
export type NormalizedAsset = ChatScenarioAccordionAsset | NormalizedImageAsset | VideoAccordionAsset;

export function normalizeAsset(asset: AccordionAssetInput): NormalizedAsset {
  if (asset.type === "video" || asset.type === "chatScenario") {
    return asset;
  }

  return { ...asset, type: "backgroundForegroundImage" };
}

export interface AccordionSlidesItem {
  asset: AccordionAssetInput;
  badge?: null | string;
  description?: ReactNode;
  icon?: Media;
  link?: ILink | null;
  linkIcon?: ReactNode | null;
  title: string;
}

export interface AccordionSlidesProps {
  className?: string;
  items: AccordionSlidesItem[];
  layout?: "center" | "spaced";
  subtitle?: null | string;
  title?: null | string;
}

export interface AccordionSlidesLazyAssetProps {
  animationKey: number | string;
  asset: NormalizedAsset;
  inView: boolean;
  isMuted: boolean;
  isPreload?: boolean;
  item?: AccordionSlidesItem;
  onInteraction: () => void;
  showControls: boolean;
  toggleMute: () => void;
  videoRef: RefObject<HTMLVideoElement | null>;
}
